<div class="auth-page">

  <!-- ── Left: brand panel ──────────────────────────────── -->
  <aside class="brand-panel">
    <svg class="brand-rings" width="900" height="900" viewBox="0 0 900 900" aria-hidden="true">
      <circle cx="450" cy="450" r="200" fill="none" stroke="var(--accent)" stroke-width="1.5"/>
      <circle cx="450" cy="450" r="300" fill="none" stroke="var(--accent)" stroke-width="1.5" stroke-dasharray="8 12" opacity="0.82"/>
      <circle cx="450" cy="450" r="400" fill="none" stroke="var(--accent)" stroke-width="1.5" opacity="0.64"/>
      <circle cx="450" cy="450" r="500" fill="none" stroke="var(--accent)" stroke-width="1.5" stroke-dasharray="4 8" opacity="0.46"/>
      <line x1="450" y1="450" x2="900" y2="450" stroke="var(--accent)" stroke-width="2" opacity="0.4"/>
      <circle cx="450" cy="450" r="8" fill="var(--accent)"/>
    </svg>

    <div class="brand-logo">
      <svg width="28" height="28" viewBox="0 0 100 100" aria-hidden="true">
        <circle cx="50" cy="50" r="38" fill="none" stroke="var(--accent)" stroke-width="9" stroke-linecap="round" stroke-dasharray="160 80" transform="rotate(35 50 50)"/>
        <line x1="50" y1="50" x2="86" y2="50" stroke="var(--accent)" stroke-width="9" stroke-linecap="round"/>
        <circle cx="86" cy="50" r="6" fill="var(--accent)"/>
        <circle cx="50" cy="50" r="4.5" fill="var(--accent)"/>
      </svg>
      <span class="brand-wordmark">GPION</span>
    </div>

    <div class="brand-headline">
      <div class="brand-pill">
        <span class="brand-pill-dot"></span>
        DEVICES ONLINE
      </div>
      <h1>Your fleet,<br/>in <em>real time</em>.</h1>
      <p>Provision, monitor, and update remote devices from a single dashboard. Built for makers, trusted by teams.</p>
    </div>

    <div class="brand-trust">
      <span>SOC 2 Type II</span><span class="sep">·</span>
      <span>End-to-end encrypted</span><span class="sep">·</span>
      <span>99.99% uptime</span>
    </div>
  </aside>

  <!-- ── Right: form panel ──────────────────────────────── -->
  <main class="form-panel">
    <div class="form-wrap">

      <!-- ── LOGIN ──────────────────────────────────────── -->
      @if(currentForm() === 'login') {
        <div class="eyebrow">SIGN IN</div>
        <h2>Welcome back</h2>
        <p class="form-sub">Don't have an account?
          <span class="link" (click)="handleChangeAuthMode('register')">Get started</span>
        </p>

        <form [formGroup]="loginForm" class="stack" (ngSubmit)="submit()">

          <div class="field">
            <input id="login-email" type="email" placeholder=" "
                   formControlName="email" autocomplete="email"
                   (keyup)="handlePressEnter($event)" autofocus />
            <label for="login-email">Work email</label>
          </div>

          <div class="field has-trailing">
            <input id="login-password" [type]="hideLoginPassword ? 'password' : 'text'"
                   placeholder=" " formControlName="password"
                   autocomplete="current-password"
                   (keyup)="handlePressEnter($event)" />
            <label for="login-password">Password</label>
            <div class="trailing">
              <button type="button" class="icon-btn" [attr.aria-label]="hideLoginPassword ? 'Show password' : 'Hide password'"
                      (click)="hideLoginPassword = !hideLoginPassword">
                @if(hideLoginPassword) {
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
                  </svg>
                } @else {
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                }
              </button>
            </div>
          </div>

          <div class="row-between">
            <span></span>
            <span class="link-muted" (click)="handleChangeAuthMode('forgot')">Forgot password?</span>
          </div>

          <button type="submit" class="btn-primary" [disabled]="auth.loading()">
            {{ auth.loading() ? 'Signing in…' : 'Sign in →' }}
          </button>

          @if(auth.errorMessages()) {
            <div class="form-error">{{ auth.errorMessages() }}</div>
          }

          <div class="auth-links">
            <span class="auth-link" (click)="handleChangeAuthMode('forgot')">Forgot password?</span>
            <span class="auth-link-sep">·</span>
            <span class="auth-link" (click)="handleChangeAuthMode('register')">Create account</span>
          </div>

        </form>
      }

      <!-- ── REGISTER ────────────────────────────────────── -->
      @if(currentForm() === 'register') {
        <div class="eyebrow">CREATE ACCOUNT</div>
        <h2>Get started</h2>
        <p class="form-sub">Already have an account?
          <span class="link" (click)="handleChangeAuthMode('login')">Sign in</span>
        </p>

        <form [formGroup]="registerForm" class="stack" (ngSubmit)="submit()">

          <div class="field">
            <input type="email" placeholder=" " formControlName="email"
                   (keyup)="handlePressEnter($event)" />
            <label>Email</label>
          </div>

          <div class="field has-trailing">
            <input [type]="hide2 ? 'password' : 'text'" placeholder=" "
                   formControlName="password" (keyup)="handlePressEnter($event)" />
            <label>Password</label>
            <div class="trailing">
              <button type="button" class="icon-btn" (click)="hide2 = !hide2">
                @if(hide2) {
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                } @else {
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                }
              </button>
            </div>
          </div>

          <div class="field has-trailing">
            <input [type]="hide ? 'password' : 'text'" placeholder=" "
                   formControlName="confirmPassword" (keyup)="handlePressEnter($event)" />
            <label>Confirm password</label>
            <div class="trailing">
              <button type="button" class="icon-btn" (click)="hide = !hide">
                @if(hide) {
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                } @else {
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                }
              </button>
            </div>
          </div>

          <button type="submit" class="btn-primary" [disabled]="auth.loading()">
            {{ auth.loading() ? 'Creating account…' : 'Create account →' }}
          </button>

          @if(auth.errorMessages()) {
            <div class="form-error">{{ auth.errorMessages() }}</div>
          }

        </form>
      }

      <!-- ── FORGOT PASSWORD ────────────────────────────── -->
      @if(currentForm() === 'forgot') {
        <div class="eyebrow">RESET PASSWORD</div>
        <h2>Forgot password?</h2>
        <p class="form-sub">We'll send a reset code to your email.</p>

        <form [formGroup]="forgotForm" class="stack" (ngSubmit)="submit()">

          <div class="field">
            <input type="email" placeholder=" " formControlName="email"
                   (keyup)="handlePressEnter($event)" />
            <label>Work email</label>
          </div>

          @if(auth.passwordRequested()) {
            <p class="form-hint">Check your inbox — enter the code below with your new password.</p>

            <div class="field">
              <input type="text" placeholder=" " formControlName="code"
                     maxlength="6" (keyup)="handlePressEnter($event)" />
              <label>Reset code</label>
            </div>

            <div class="field">
              <input type="password" placeholder=" " formControlName="newPassword"
                     (keyup)="handlePressEnter($event)" />
              <label>New password</label>
            </div>

            <div class="field">
              <input type="password" placeholder=" " formControlName="confirmNewPassword"
                     (keyup)="handlePressEnter($event)" />
              <label>Confirm new password</label>
            </div>
          }

          <button type="submit" class="btn-primary" [disabled]="auth.loading()">
            {{ auth.loading() ? 'Sending…' : (auth.passwordRequested() ? 'Set new password →' : 'Send reset link →') }}
          </button>

          @if(auth.errorMessages()) {
            <div class="form-error">{{ auth.errorMessages() }}</div>
          }

          <span class="link-muted center" (click)="handleChangeAuthMode('login')">← Back to sign in</span>

        </form>
      }

      <!-- ── CONFIRM ────────────────────────────────────── -->
      @if(currentForm() === 'confirm') {
        <div class="eyebrow">VERIFY EMAIL</div>
        <h2>Check your inbox</h2>
        <p class="form-sub">Enter the 6-digit code we sent to <strong>{{ confirmEmail }}</strong></p>

        <div class="stack">
          <div class="field">
            <input type="email" placeholder=" " [(ngModel)]="confirmEmail" name="confirmEmail" />
            <label>Email</label>
          </div>

          <div class="field">
            <input type="text" placeholder=" " [(ngModel)]="newConfirmCode" #codeInput="ngModel"
                   name="confirmationCode" maxlength="6" pattern="[0-9]*"
                   (ngModelChange)="handleConfirmCodeChange($event)" />
            <label>6-digit code</label>
          </div>

          @if(auth.errorMessages()) {
            <div class="form-error">{{ auth.errorMessages() }}</div>
          }

          <span class="link-muted center" (click)="handleChangeAuthMode('login')">← Back to sign in</span>
        </div>
      }

    </div>
  </main>

</div>
